/**
 * FilterHook is a class that allows you to apply a series of filter functions to an input.
 */

type FilterFunction<T> = (input: T, args: any) => T;

export default class FilterHook<T> {
	private filters: FilterFunction<T>[] = [];

	/** Accept initial filter functions */
	public constructor(...filters: FilterFunction<T>[]) {
		this.filters.push(...filters);
	}

	/** Add a filter function */
	public add(...filters: FilterFunction<T>[]): void {
		this.filters.push(...filters);
	}

	/** Remove a specific filter function */
	public remove(filter: FilterFunction<T>): void {
		this.filters = this.filters.filter((f) => f !== filter);
	}

	// Apply all filter functions to the input
	public apply(input: T, args: any = undefined): T {
		return this.filters.reduce((result, filter) => filter(result, args), input);
	}
}
